<template>
  <div>
    <button class="button is-primary" style="width:140px" @click="showModal">적립금 일괄 지급</button>

    <modal name="pointPaymentPopup" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="box">
        <admin-box-item title="적립금 일괄 지급">
          <admin-form-item label="적립금액">
            <lp-radio :val.sync="value.review_payment_type"
                      value_name="value"
                      label_name="label"
                      :data="[{label:'자동 계산',value:true}, {label:'직접 입력', value:false}]"></lp-radio>

            <!-- 자동 계산 -->
            <span class="desc1" v-if="value.review_payment_type">
              <span class="unselect"
                    style="text-decoration: underline"
                    @click="openPointSetting">적립금/쿠폰 관리 > 적립금 설정</span>
          에서 설정한 금액을 기준으로 자동 계산 됩니다.</span>

            <!-- 직접 입력 -->
            <div v-else style="margin-top:12px">
              <div class="flex-align">
                <div class="input-title">금액</div>
                <input class="input"
                       type="number"
                       placeholder="0"
                       v-model="value.point"
                       @input="e=>setNumber(e)" style="width:100px">
                <span style="margin-left:8px">원</span>
              </div>

              <div class="flex-align" style="margin-top:8px">
                <div class="input-title">내용</div>
                <input class="input"
                       type="text"
                       placeholder="지급 사유"
                       :value="value.content"
                       @input="e=>value.content = e.target.value">
              </div>
            </div>
            <div style="margin:20px 0 12px 0">
              <div class="label">적립금 지급 대상 (총 {{ totalCount }}건)</div>
              <div v-if="value.review_payment_type===false" style="margin-top:8px">
                <lp-radio :val.sync="value.duplicate"
                          value_name="value"
                          label_name="label"
                          :data="duplicateRadioData"></lp-radio>
              </div>
            </div>

            <!-- 테이블 -->
            <div style="max-height:225px;overflow-y: scroll">
              <table class="point-payment-table">
                <thead>
                <tr>
                  <th v-if="(value.review_payment_type && value.hasMany) || (!value.review_payment_type && !value.duplicate && value.hasMany)" colspan="2">회원 x 후기수</th>
                  <th v-else>회원</th>
                  <th>총 적립 금액</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(user, idx) in users" :key="`user-${idx}`">
                  <td>{{ user.author }}</td>
                  <td v-if="(value.review_payment_type && value.hasMany) || (!value.review_payment_type && !value.duplicate && value.hasMany)">{{ user.reviews.length }}</td>
                  <td>{{ user.total_point }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </admin-form-item>
          <div class="btn-group-justify-end">
            <button class="button is-primary" @click="saveData">적립금 지급</button>
          </div>
        </admin-box-item>
      </div>
    </modal>
  </div>
</template>
<script>
  import LpRadio from "../../../module/common/LpRadio";
  import LpCheckBool from "../../../module/common/LpCheckBool";

  export default {
    name: "PointPaymentPopup",
    props: {
      review_list: {
        type: Array
      },
      point_setting: {
        type: Object
      }
    },
    components: {LpCheckBool, LpRadio},
    data() {
      return {
        value: {
          point: 0,
          content: '',          // 지급 사유
          review_payment_type: true,  // 적립금액 자동계산 / 직접입력 여부
          duplicate: false,   // 1회만 지급 체크 여부
          hasMany: false      // 회원당 후기수가 2이상 있는 경우
        },
        users: [],
        duplicateRadioData: [
          {label: '후기 게시글 건별로 지급', value: false},
          {
            label: '회원(ID)당 1건만 지급', value: true,
            tip : '한 회원당 2개 이상의 후기가 선택되어\n있어도 한 건에만 적립금이 지급됩니다.\n(가장 최신 게시글에 적립)'
          }
        ]
      }
    },
    computed: {
      totalCount() {
        let value = this.value;
        if((value.review_payment_type && value.hasMany) || (!value.review_payment_type && !value.duplicate)) {
          return this.review_list.length;
        } else {
          return this.users.length;
        }
      }
    },
    watch: {
      value: {
        handler() {
          // 자동 계산
          if(this.value.review_payment_type) {
            this.users.forEach(user => {
              user.total_point = user.reviews.reduce((acc, cur) => {
                return acc + cur.calc_point;
              }, 0);
            });
          }
          // 직접 입력
          else {
            this.calcPoint();
          }
        },
        deep: true
      }
    },
    methods: {
      openPointSetting() {
        window.open(this.getPath('point/setting'));
      },
      calcPoint() {
        this.users.forEach(user => {
          // 1회만 지급
          if(this.value.duplicate) {
            user.total_point = this.value.point;
          } else {
            user.total_point = this.value.point * user.reviews.length;
          }
        });
      },
      setNumber(e) {
        let point = parseInt(e.target.value.substr(0, 5));
        if(point < 0) {
          point = 0;
        }
        this.value.point = point;
      },
      showModal() {
        if(this.review_list.length===0) {
          this.toast('먼저 적립금을 지급할 리뷰를 선택해주세요');
          return;
        }
        this.value.hasMany = false;
        let user_list = [];
        this.review_list.forEach(item => {
          let reviewData = {
            id: item.id,
            calc_point : item.calc_point
          };
          let user = find(user_list, 'author_id', item.author_id);
          if(!user) {
            user_list.push({
              author_id: item.author_id,
              author: item.author,
              reviews: [reviewData],
              total_point : reviewData.calc_point
            });
          } else {
            user.reviews.push(reviewData);
            user.total_point += reviewData.calc_point;
            this.value.hasMany = true;
          }

        });
        this.users = user_list;
        this.$modal.show('pointPaymentPopup');
      },
      saveData () {
        let params = this.value;
        params.users = this.users;

        this.$axios.post('admin/point/payments/review', params).then(res=>{
          if(res.status === 200) {
            this.toast('적립금이 지급되었습니다');
            this.$modal.hide('pointPaymentPopup');
          }
        });
      }
    }
  }
</script>
<style lang="stylus" scoped>
  .desc1
    color #9A9A9A
    font-size 12px

  .point-payment-table th
  .point-payment-table td
    text-align center !important
    font-size 12px
    width 33.3%

  .point-payment-table th
    font-weight bold
    background-color #F5F5F5

  .input-title
    width 40px
  input[type="text"]
    width 124px
</style>
